import { defineComponent as M, openBlock as t, createElementBlock as o, mergeProps as m, unref as e, renderSlot as H, createElementVNode as Z, createCommentVNode as d } from "vue";
import { useScalarIcon as h } from "../hooks/useScalarIcon.js";
const p = { key: 0 }, i = { key: 1 }, u = { key: 2 }, g = { key: 3 }, A = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconSketchLogo"
}, _ = /* @__PURE__ */ M({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(a) {
    const r = a, { bind: s, weight: n } = h(r);
    return (L, l) => (t(), o("svg", m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      H(L.$slots, "default"),
      e(n) === "bold" ? (t(), o("g", p, l[0] || (l[0] = [
        Z("path", { d: "M249,96.1l-56-64a12,12,0,0,0-9-4.1H72a12,12,0,0,0-9,4.1L7,96.1a12,12,0,0,0,.26,16.09l112,120a12,12,0,0,0,17.54,0l112-120A12,12,0,0,0,249,96.1ZM213.55,92H182L152,52h26.55ZM71.88,116l21.19,53L43.61,116Zm86.4,0L128,191.69,97.72,116ZM104,92l24-32,24,32Zm80.12,24h28.27l-49.46,53ZM77.45,52H104L74,92H42.45Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (t(), o("g", i, l[1] || (l[1] = [
        Z("path", {
          d: "M240,104,128,224,80,104l48-64h56Z",
          opacity: "0.2"
        }, null, -1),
        Z("path", { d: "M246,98.73l-56-64A8,8,0,0,0,184,32H72a8,8,0,0,0-6,2.73l-56,64a8,8,0,0,0,.17,10.73l112,120a8,8,0,0,0,11.7,0l112-120A8,8,0,0,0,246,98.73ZM222.37,96H180L144,48h36.37ZM74.58,112l30.13,75.33L34.41,112Zm89.6,0L128,202.46,91.82,112ZM96,96l32-42.67L160,96Zm85.42,16h40.17l-70.3,75.33ZM75.63,48H112L76,96H33.63Z" }, null, -1)
      ]))) : e(n) === "fill" ? (t(), o("g", u, l[2] || (l[2] = [
        Z("path", { d: "M246,98.73l-56-64A8,8,0,0,0,184,32H72a8,8,0,0,0-6,2.73l-56,64a8,8,0,0,0,.17,10.73l112,120a8,8,0,0,0,11.7,0l112-120A8,8,0,0,0,246,98.73ZM222.37,96H180L144,48h36.37ZM74.58,112l30.13,75.33L34.41,112Zm106.84,0h40.17l-70.3,75.33ZM75.63,48H112L76,96H33.63Z" }, null, -1)
      ]))) : e(n) === "light" ? (t(), o("g", g, l[3] || (l[3] = [
        Z("path", { d: "M244.52,100.05l-56-64A6,6,0,0,0,184,34H72a6,6,0,0,0-4.52,2l-56,64a6,6,0,0,0,.13,8l112,120a6,6,0,0,0,8.78,0l112-120A6,6,0,0,0,244.52,100.05ZM75.94,110l34.6,86.49L29.81,110Zm91.2,0L128,207.84,88.86,110ZM92,98l36-48,36,48Zm88.06,12h46.13l-80.73,86.49Zm46.72-12H179L140,46h41.28ZM74.72,46H116L77,98H29.22Z" }, null, -1)
      ]))) : e(n) === "regular" ? (t(), o("g", A, l[4] || (l[4] = [
        Z("path", { d: "M246,98.73l-56-64A8,8,0,0,0,184,32H72a8,8,0,0,0-6,2.73l-56,64a8,8,0,0,0,.17,10.73l112,120a8,8,0,0,0,11.7,0l112-120A8,8,0,0,0,246,98.73ZM222.37,96H180L144,48h36.37ZM74.58,112l30.13,75.33L34.41,112Zm89.6,0L128,202.46,91.82,112ZM96,96l32-42.67L160,96Zm85.42,16h40.17l-70.3,75.33ZM75.63,48H112L76,96H33.63Z" }, null, -1)
      ]))) : e(n) === "thin" ? (t(), o("g", f, l[5] || (l[5] = [
        Z("path", { d: "M243,101.37l-56-64A4,4,0,0,0,184,36H72a4,4,0,0,0-3,1.37l-56,64a4,4,0,0,0,.09,5.36l112,120a4,4,0,0,0,5.84,0l112-120A4,4,0,0,0,243,101.37ZM77.29,108l39.07,97.66L25.2,108Zm92.8,0L128,213.23,85.91,108ZM88,100l40-53.33L168,100Zm90.71,8H230.8l-91.16,97.66Zm52.47-8H178L136,44h46.18ZM73.82,44H120L78,100H24.82Z" }, null, -1)
      ]))) : d("", !0)
    ], 16));
  }
});
export {
  _ as default
};
